import React, { useState } from "react";
import {
    Row,
    Col,
    Button,
    FormGroup,
    Modal,
    ModalBody,
} from "reactstrap";
import { authenticationService } from '_services';
import { handleResponse } from '_helpers';
import Datetime from 'react-datetime';
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";

//function Register() {
const TSListAdminAppoint = (props) => {

    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);

    const [flow, setFlow] = useState('');
    const [titleOption, setTitleOption] = useState([]);

    const [modalMsg, setModalMsg] = useState(false);
    const [modalLine, setModalLine] = useState(false);

    const [renderItem, setRenderItem] = useState([]);
    const [AppointDatetime, setAppointDatetime] = useState(null);
    const [Keyword, setKeyword] = useState(null);
    const [BookingID, setBookingID] = useState(null);
    const [BookingStatus, setBookingStatus] = useState(null);
    const [value, setValue] = useState(null);
    const [icon, setIcon] = useState("far fa-question-circle");

    React.useEffect(() => {
        const currentUser = authenticationService.currentUserValue;

        if (currentUser) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                     //'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0b245MDAiLCJqdGkiOiI4MzUxNTU1Yi04OTZhLTQ1MTktOWU4ZC04MThhMmQ4NTg4NzMiLCJpZCI6Ijg2NjRkYmVmLWQ3ZGQtNDdlZC05NGJhLTc5NzQ5ZjFjOGFkOSIsInJvbGUiOiJBZG1pbiIsIm5iZiI6MTYxMzAyNTcwMywiZXhwIjoxNjEzMDI5MzAzLCJpYXQiOjE2MTMwMjU3MDN9.lNBDaZbsJNUBRKxj1W23SoF8Bj9uPlu7hbJD6aErC78',//'Bearer ' + authenticationService.currentUserValue.token,
                   'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/bookings', requestOptions)
                .then(handleResponse)
                .then(
                    (result) => {
                        //console.log('test')
                        setRenderItem(result.data);
                    },
                    (error) => {
                        //console.log(error);
                    }
                )
        }

        fetch("/api/bookingstatus"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setTitleOption(result.data) }, (error) => { console.log(error) })


        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };

    }, []);

    const setDate = (e) => {
        setAppointDatetime(e);
        setValue(e)


        if (e != null && e != '') {
            var url = '/api/v1/bookings?AppointDatetime=' + e + ((flow != null) ? '&BookingStatus=' + flow : '');
            retriveData(url);
        }
        else {
            var url = '/api/v1/bookings' + ((e != null) ? '?BookingStatus=' + flow : '');
            retriveData(url);
        }
    }

    const setStatus = (e) => {
        setFlow(e);

        if (e != null && e != '') {
            var url = '/api/v1/bookings?BookingStatus=' + e + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '');
            retriveData(url);
        }
        else {
            var url = '/api/v1/bookings' + ((AppointDatetime != null) ? '?AppointDatetime=' + AppointDatetime : '');
            retriveData(url);
        }
    }

    const retriveData = url => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            }
        };

        fetch(url, requestOptions)
            //.then(response => response.json())
            .then(handleResponse)
            .then(
                (result) => {
                    setRenderItem(result.data);

                },
                (error) => {
                    setRenderItem([]);
                }
            )
    };



    const handleLine = e => {
        if (e.target.getAttribute('bookingid') != null) {
            const status = e.target.getAttribute('status');
            const bookingid = e.target.getAttribute('bookingid');
            const fullname = e.target.getAttribute('fullname');


            setBookingID(e.target.getAttribute('bookingid'));
            setBookingStatus(e.target.getAttribute('status'));
            setModalMsg('คุณ ' + e.target.getAttribute('fullname'));

            setModalLine(true);
            /*
            console.log(teleid);
            console.log(fullname);
            console.log(phone);
            console.log(teleid);
            */
        }

    };
    const handleHN = e => {
        if (e.target.getAttribute('userID') != null) {
            const userID = e.target.getAttribute('userID');
            window.location.href = "/user/" + userID;
        }

    };

    const handleStatus = (evt, status) => {
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        evt.preventDefault();
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "bookingStatus": status,
            })
        };

        fetch('/api/v1/bookings/updatestatus/' + BookingID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    
                    var txt = (status == 1) ? "#ยืนยันการมารับบริการ" : (status == -1) ? "#ยกเลิกนัดหมาย" : "";
                    var THDate = moment(result.data.appointDatetime).add(543, 'year').format('Do MMMM YYYY');
                    var AppointTime = result.data.appointTime;
                    console.log(`${txt} - วันที่ ${THDate} เวลา ${AppointTime.substring(0, 5)} น. `)

                    setIcon("far fa-question-circle");
                    setModalLine(false);

                    var url = '';
                    if (AppointDatetime != null && flow != null)
                        url = '/api/v1/bookings?AppointDatetime=' + AppointDatetime + '&BookingStatus=' + flow;
                    else if (AppointDatetime != null && (flow == null || flow ==''))
                        url = '/api/v1/bookings?AppointDatetime=' + AppointDatetime;
                    else if (AppointDatetime == null && flow != null && flow != '' )
                        url = '/api/v1/bookings?BookingStatus=' + flow;
                    else
                        url = '/api/v1/bookings';

                    retriveData(url);


                },
                (error) => {
                    alert(error);
                }
            )
    }


    const handleLineCall = (evt) => {
        console.log(evt)
        /*
        if (TeleID != null) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/tele/call/' + TeleID, requestOptions)
                .then(handleResponse)
                .then(
                    (result) => {
                        console.log(result);
                        window.alert("แจ้งเตือนเรียบร้อยแล้ว");
                        setModalLine(false);

                        var url = '/api/v1/tele?AppointDatetime=' + AppointDatetime
                        retriveData(url);

                        window.open('/vdoadmin/' + TeleID, 'Data', 'fullscreen=yes');
                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }
        */
    };


    /*
  
      handleChange = event => {
          setValue(event.target.value);
  
          if (this.props.onChange)
              this.props.onChange(event);
      };
  
      setKeyword(e) {
          this.setState(state => ({
              Keyword: e
          }));
      }
  
  
      const handleConfirm = (evt) => {
          evt.preventDefault();
          setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
  
          var birthdate = moment([bYear, bMonth - 1, bDay]);
  
          const requestOptions = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json-patch+json',
              },
              body: JSON.stringify({
                  "username": Username,
                  "password": Password,
                  "email": Email,
                  "lineTrangskin": LineTrangskin,
                  "firstName": FirstName,
                  "lastName": LastName,
                  "idCard": CID,
                  "phone": phone,
                  "birthDate": birthdate.format('YYYY-MM-DD')
              })
          };
  
          fetch('/api/v1/identity/web-register', requestOptions)
              .then(response => response.json())
              .then(
                  (result) => {
  
  
                      if (liff.isInClient()) {
  
                          liff.sendMessages([{
                              'type': 'text',
                              'text': '#registered'
                          }]).then(function () {
                              //window.alert('Message sent');
                              liff.closeWindow();
                          }).catch(function (error) {
                              window.alert('Error sending message: ' + error);
                          });
  
                      } else {
                          authenticationService.login(Username, Password)
                              .then(
                                  user => {
                                      const { from } = props.location.state || { from: { pathname: "/profile" } };
                                      props.history.push(from);
                                  },
                                  error => {
  
                                      if (result.errors !== "undefined") {
                                          try {
  
                                              setModal2(false);
                                              setIcon("far fa-question-circle");
                                              setErrMsg(result.errors[0]);
                                              setModalError(true);
  
                                          }
                                          catch (e) { console.log(e) }
                                      }
  
                                  }
                              );
                      }
  
                  },
                  (error) => {
                      alert(error);
                  }
              )
      }
  */

    const content = renderItem.map((post, index) =>
        <Row key={index} style={{
            fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd', backgroundColor: (post.bookingStatus == 1) ? '#0080001f' : (post.bookingStatus == -1) ? '#ff00001f' : 'white'  }}>
            <Col md="2" xs="6">
                <a href={"#" + post.bookingID} > {post.fullName}  </a>
                <a href={`/user/${post.userID}`} target="_blank">
                    <i className="fas fa-user" style={{
                    left: '18px',
                    top: '18px',
                    fontSize: '1rem'
                }}
                ></i>
                </a>
                <a href={`tel:${post.phone}`}>โทร.{post.phone}</a>
            </Col>
            <Col md="2" xs="6">
                {post.appointDatetimeText}
            </Col>
            <Col md="2" xs="6">
                {post.serviceTypeName} {post.slotTypeName}
            </Col>
            <Col md="2" xs="6" style={{ color: (post.bookingStatus == 1) ? "green" : (post.bookingStatus == -1) ? "red" : "black" }}>
                {post.bookingStatusName}
            </Col>
            <Col md="4" xs="12">
                {
                    (post.hn == null) ?
                        <Button color="gray" size="sm" val="1"
                            userID={post.userID}
                            onClick={handleHN}>
                            <i className="fas fa-user-plus" style={{ fontSize: '1.2em', color: 'white' }}></i> สร้างHN
                        </Button>
                        : ""

                }


                <Button
                    bookingid={post.bookingID}
                    fullname={post.fullName}
                    status={1}
                    onClick={handleLine} color={(post.bookingStatus == 1) ? "success" : "primary"} size="sm" val="1"><i className="fas fa-calendar-check"></i> ยืนยันการมา </Button>

                <Button
                    bookingid={post.bookingID}
                    fullname={post.fullName}
                    status={-1}
                    onClick={handleLine} color={(post.bookingStatus == -1) ? "danger" : "primary"} size="sm" val="1"><i className="fas fa-calendar-times"></i> ยกเลิกนัด </Button>
    
               


            </Col>
        </Row>
    );

    var moment = require('moment');
    require('moment/locale/th');

    var renderers = {
        renderDay: function (props, currentDate, selectedDate) {
            return <td {...props}>{currentDate.date()}</td>;
        },
        renderMonth: function (props, month, year, selectedDate) {
            return <td {...props}>{month}</td>;
        },
        renderYear: function (props, year, selectedDate) {
            return <td {...props}>{year}</td>;
        }
    }


    return (
        <>
            <div /*style={{ backgroundColor: '#2ca8ff1f' }}*/>

                <Row>
                    <Col className="text-right" xs="6">
                        <FormGroup
                            style={{ padding: '0 0px', marginBottom: '10px' }}
                            className="input-lg"
                        >
                            <i className="now-ui-icons ui-1_calendar-60" style={{
                                position: 'absolute',
                                left: '18px',
                                top: '18px',
                                zIndex: 1,
                                fontSize: '1rem'
                            }}
                            ></i>
                            <Datetime
                                renderDay={renderers.renderDay}
                                renderYear={renderers.renderYear}
                                isValidDate={e => e.day() !== 0 && e.day() !== 6}
                                inputProps={{ name: "AppointDatetime", placeholder: "วันที่รับบริการ", readOnly: 'readonly', style: { fontSize: '1.2em', paddingLeft: '50px', cursor: 'pointer' } }}
                                closeOnSelect={true}
                                closeOnTab={true}
                                dateFormat="DD MMMM YYYY" timeFormat={false}
                                onChange={e => setDate(e.format('YYYY-MM-DD HH:mm'))}
                                value={value}
                            />

                        </FormGroup>
                    </Col>


                    <Col className="text-left" xs="3" >
                        <Button className="btn-icon btn-round" color="primary" onClick={e => setDate('')}>
                            <i className="fas fa-times"></i>
                        </Button>
                    </Col>
                    <Col xs="3" style={{ marginTop: -20 }}>
                        สถานะ<TSSelect isDefault options={titleOption} onChange={e => setStatus(e)} value={flow} />
                    </Col>
                    {/*
                    <Col className="text-center ml-auto mr-auto" lg="6" sm="12">
                        <TSText name="Keyword" placeholder="ค้นหา ชื่อ, เลขบัตรประชาชน" onChange={e => this.setKeyword(e.target.value)} icon="tech_mobile" />
                    </Col>
                    */}
                </Row>

                <Row style={{ fontWeight: 'bold', fontSize: '1em', padding: '10px 10px', borderBottom: '2px solid #dddddd' }}>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        ชื่อ
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        วันที่นัด
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        ประเภท
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        สถานะ
                    </Col>
                    <Col md="4" xs="12" className="d-none d-sm-block">
                        จัดการ
                    </Col>
                </Row>
                {content}
            </div>
            <Modal
                modalClassName={(BookingStatus == 1) ? "modal-mini modal-info" : "modal-mini modal-danger"} 
                toggle={() => setModalLine(false)}
                isOpen={modalLine}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody>
                    
                    <p>{(BookingStatus == 1) ? "ยืนยันการมา" : "ยกเลิกนัด"}</p>
                    <p> {modalMsg} </p>
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={() => setModalLine(false)}
                    >
                        ยกเลิก
                                      </Button>

                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
        
                        onClick={e => handleStatus(e, BookingStatus)}
                        disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                        //onClick={() => setModal2(false)}
                    >
                        ยืนยัน
                    </Button>



                </div>
            </Modal>
        </>
    );
}

export default TSListAdminAppoint;
